export default __webpack_public_path__ + "static/media/chat-bot.c040c4c3.svg";